import FilterInputWithSuggestions from "@/components/FilterInputWithSuggestions";
import { cn, verifyEmail } from "@/lib/utils";
import { Users, X } from "lucide-react";
import { eventFormTone, type EventFormTone } from "./eventFormTone";

type EventAttendeesInputProps = {
    attendees: string[];
    setAttendees: (attendees: string[]) => void;
    tone?: EventFormTone;
};

const EventAttendeesInput = ({
    attendees,
    setAttendees,
    tone = "dark",
}: EventAttendeesInputProps) => (
    <div className="flex items-start gap-2">
        <Users
            className={cn(
                "mt-2.5 h-4 w-4 flex-shrink-0",
                eventFormTone[tone].icon,
            )}
        />
        <div
            className={cn(
                "flex w-full flex-wrap gap-2 rounded-md border p-3",
                eventFormTone[tone].border,
            )}
        >
            {attendees?.map((value) => (
                <p
                    key={value}
                    className={cn(
                        "mb-1 flex w-fit items-center gap-1 rounded-md px-2 py-1 text-xs",
                        eventFormTone[tone].chip,
                    )}
                >
                    {value}
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            setAttendees?.(
                                attendees?.filter((v) => v !== value),
                            );
                        }}
                        type="button"
                    >
                        <X
                            className={cn(
                                "cursor-pointer",
                                eventFormTone[tone].chipRemove,
                            )}
                            size={14}
                        />
                    </button>
                </p>
            ))}
            <FilterInputWithSuggestions
                className={cn(
                    "placeholder:text-sm",
                    eventFormTone[tone].placeholder,
                )}
                setValues={setAttendees}
                suggestionListClassName="bg-white text-foreground"
                validator={verifyEmail}
                values={attendees}
            />
        </div>
    </div>
);

export default EventAttendeesInput;
